import { render } from "./PainelNotas.vue?vue&type=template&id=01de2ad4&scoped=true"
import script from "./PainelNotas.vue?vue&type=script&lang=js"
export * from "./PainelNotas.vue?vue&type=script&lang=js"

import "./PainelNotas.vue?vue&type=style&index=0&id=01de2ad4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01de2ad4"]])

export default __exports__